export default __webpack_public_path__ + "static/faq-header-bg-d5d4523afa351f790032b3278cf9aaa9.gif";